// ============================================================================
// Tabela de dados — capítulo novo do DS (nascido na refatoração visual de
// Transferências, 2026-09-10). Camada NOVA: o legado `styles/table/Table.js`
// continua existindo e migra ao ser tocado (FC1 §A.10 / FC7).
//
// Anatomia (UI_SPEC do handoff de design de transferências):
//   · thead escuro (`appBackground`), 11px caixa alta, peso 800;
//   · zebra sutil no tbody, célula 13px com padding 11/14;
//   · números alinham à direita (`className="num"`), `center` continua valendo;
//   · ordenação: `className="sortable"` (+ `sort-active` na coluna ativa) SÓ
//     nas colunas da whitelist de `order_by` do backend — cabeçalho clicável
//     fora dela é ordenação fantasma (navegacao.md §1.10). Os ícones do ciclo
//     continuam sendo os ratificados ⇅ ▲ ▼ (navegacao.md §1.9), renderizados
//     pela tela; aqui mora só a affordance (cursor, hover e cor da ativa).
//
// A zebra usa `:not(:hover)` de propósito: sem isso ela vence, por
// especificidade, o hover azul que o `ClickableRow` (styles/ui/Link.js) pinta
// no td — e linha clicável de linha par ficaria sem feedback.
//
// Scroll horizontal: continuar envolvendo em `styles/table/TableWrapper`
// (passa o $minWidth lá) — tabela larga rola, não esmaga a coluna de nome.
// ============================================================================
import styled from 'styled-components';

// Cor de destaque da coluna ordenada sobre o thead escuro. Não é cor de ação
// (G.1) — é affordance de ordenação; vive só aqui, no primitivo.
const SORT_ACTIVE_ON_DARK = '#8fd0ff';

export const DataTable = styled.table`
   width: 100%;
   border-collapse: collapse;

   /* nowrap suprime só a quebra AUTOMÁTICA — <br/> continua valendo. Header
      longo em layout apertado quebra em duas linhas com <br/> deliberado
      (ex.: "Disponível<br/>na origem"), reduzindo o min-content da coluna. */
   thead th {
      text-align: left;
      padding: 10px 14px;
      background: ${({ theme }) => theme.colors.appBackground};
      color: #fff;
      font-size: 11px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      line-height: 1.35;
      white-space: nowrap;
   }

   thead th.sortable {
      cursor: pointer;
      user-select: none;

      &:hover {
         color: ${SORT_ACTIVE_ON_DARK};
      }
   }

   thead th.sort-active {
      color: ${SORT_ACTIVE_ON_DARK};
   }

   tbody td {
      padding: 11px 14px;
      font-size: 13px;
      color: ${({ theme }) => theme.colors.textPrimary};
      border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
      vertical-align: middle;
   }

   /* A zebra cede em duas situações: no hover (senão ela vence, por
      especificidade, o azul do ClickableRow) e em linha MARCADA por estado
      ([data-flagged] — ex.: linha inválida/em falta nas grades de modal), que
      pinta o próprio fundo sem precisar de !important (G.6). */
   tbody tr:nth-child(even):not(:hover):not([data-flagged]) td {
      background: #fafafb;
   }

   th.center,
   td.center {
      text-align: center;
   }

   th.num,
   td.num {
      text-align: right;
      font-variant-numeric: tabular-nums;
   }

   td.nowrap,
   th.nowrap {
      white-space: nowrap;
   }
`;

// Célula secundária (datas, ids de apoio) — texto rebaixado sem trocar o porte.
export const MutedCell = styled.span`
   color: ${({ theme }) => theme.colors.textMuted};
`;
